export const initialFormData = {
    general: {
      cr_project_name: '',
      environment: 'testbed',
      validity_period: '90'
    },
    Prepaid: {
      MSISDN: { store_id: '', material_code: '', quantity: '' },
      'Blank Sim': { store_id: '', material_code: '', quantity: '' }
    },
    'Starter Pack': {
      RM5: { store_id: '', material_code: '', quantity: '' },
      RM10: { store_id: '', material_code: '', quantity: '' },
      RM30: { store_id: '', material_code: '', quantity: '' },
      Others: { store_id: '', material_code: '', quantity: '' }
    },
    Reload: {
      RM5: { store_id: '', material_code: '', quantity: '' },
      RM10: { store_id: '', material_code: '', quantity: '' },
      RM30: { store_id: '', material_code: '', quantity: '' },
      RM50: { store_id: '', material_code: '', quantity: '' }
    },
    Softpin: {
      RM5: { store_id: '', material_code: '', quantity: '' },
      RM10: { store_id: '', material_code: '', quantity: '' },
      RM20: { store_id: '', material_code: '', quantity: '' },
      RM30: { store_id: '', material_code: '', quantity: '' },
      RM50: { store_id: '', material_code: '', quantity: '' },
      RM100: { store_id: '', material_code: '', quantity: '' }
    }
  };